import keymirror from 'keymirror'

export const FILE_UPLOAD_STATUS = keymirror({
  UPLOADING: null,
  SUCCESS: null,
  ERROR: null,
})
